import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from 'app/routes';
import Modal from 'components/new_ui/Modal/Modal';

export default function BuildProgramModal({ show, onHide, existingProgramUrl }) {
  return (
    <Modal
      header="Before You Build A New Program"
      size="lg"
      show={show}
      onHide={onHide}
    >
      <p>
        Did you know? You can personalize your assigned program or if you&apos;re already on your path
        to development pick up where you left off.
      </p>

      <p>
        Start your assigned program or continue you current
        program by clicking &ldquo;Go To My Program&rdquo; to ensure seamless progress.
        If you still would like to build a new program click on &ldquo;Build New Program&rdquo; to begin.
      </p>

      <footer className="d-flex justify-content-center">
        <Link
          to={existingProgramUrl}
          className="btn btn-outline-primary px-3"
        >
          Go To My Program
        </Link>

        <Link
          to={routes.members.programs.new.index}
          className="btn btn-primary px-3"
        >
          Build New Program
        </Link>
      </footer>
    </Modal>
  );
}

BuildProgramModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  existingProgramUrl: PropTypes.string.isRequired,
};
